import React, { useContext } from 'react'
import styled from 'styled-components'
import Card from 'react-bootstrap/Card'
import Brands from './brands'
import Badge from 'react-bootstrap/Badge'
import { JazeelContext } from '../../../../utils/JazeelContext'

const Wrapper = styled(Card)`
  box-shadow: 0 2px 26px 0 rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  padding: 1.438em 1.813em 1.5em;
  margin-top: 1.875em;
  background: white;
  @media screen and (max-width: 350px) {
    padding-left: 1em;
    padding-right: 1em;
  }
`
const Title = styled.h1`
  color: #212529;
  font-size: 1.5em;
  font-weight: bold;
  line-height: 1.813em;
  margin-bottom: 1.2em;
`

export default function JoinedBrands() {
  const { userData } = useContext(JazeelContext)
  return (
    <Wrapper>
      <Card.Body className="p-0">
        <Title>
          All Brands He Joined{' '}
          <Badge variant="warning float-right">
            {userData.all_brands?.length}
          </Badge>
        </Title>
        <Brands />
      </Card.Body>
    </Wrapper>
  )
}
